import { CommunityXpActionKey } from '../policies/community-gamification.policy';

export type CommunityLevelDefinition = {
  level: number;
  name: string;
  xpRequired: number;
};

export type CommunityXpRuleDefinition = {
  actionKey: string;
  points: number;
  enabled: boolean;
};

export const DEFAULT_COMMUNITY_LEVELS: CommunityLevelDefinition[] = [
  { level: 1, name: 'Newcomer', xpRequired: 0 },
  { level: 2, name: 'Regular', xpRequired: 50 },
  { level: 3, name: 'Contributor', xpRequired: 150 },
  { level: 4, name: 'Champion', xpRequired: 400 },
  { level: 5, name: 'Legend', xpRequired: 1000 },
];

export const DEFAULT_COMMUNITY_XP_RULES: CommunityXpRuleDefinition[] = [
  { actionKey: CommunityXpActionKey.POST, points: 10, enabled: true },
  { actionKey: CommunityXpActionKey.COMMENT, points: 5, enabled: true },
  { actionKey: CommunityXpActionKey.LIKE_RECEIVED, points: 1, enabled: true },
  { actionKey: CommunityXpActionKey.REFERRAL_JOIN, points: 25, enabled: true },
];

export type CommunityLeaderboardWindow = 'daily' | 'weekly' | 'all';

export function resolveMemberLevel(
  totalXp: number,
  levels: CommunityLevelDefinition[],
): number {
  const sorted = [...levels].sort((a, b) => a.xpRequired - b.xpRequired);
  let current = sorted[0]?.level ?? 1;
  for (const entry of sorted) {
    if (totalXp >= entry.xpRequired) {
      current = entry.level;
    }
  }
  return current;
}

export function memberMeetsMinLevel(memberLevel: number, minLevel: number | null | undefined): boolean {
  if (minLevel == null || minLevel <= 0) return true;
  return memberLevel >= minLevel;
}

export function levelNameFor(
  levelNumber: number,
  levels: CommunityLevelDefinition[],
): string {
  return levels.find((entry) => entry.level === levelNumber)?.name ?? `Level ${levelNumber}`;
}
